import React from 'react'; 
import styled from 'styled-components';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, } from 'recharts';
import moment from 'moment'

import StateDispatch from './contextInfo'


const CardMonthsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: 0.2rem;
`
  const Title = styled.h2`
    font-size: 1.2em;
    font-weight: 400; 
    line-height: 100%;
    letter-spacing: 0.05em;
    padding-top: 1rem;
    color: #373D3F;
  `
  const RadarChartWrapper = styled.div`
  flex-grow: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  `

function transformMonth(month) {
  if (month === 'Jan') return '0'
  else if (month === 'Feb') return '1'
  else if (month === 'Mar') return '2'
  else if (month === 'Apr') return '3'
  else if (month === 'May') return '4'
  else if (month === 'Jun') return '5'
  else if (month === 'Jul') return '6'
  else if (month === 'Aug') return '7'
  else if (month === 'Sep') return '8'
  else if (month === 'Oct') return '9'
  else if (month === 'Nov') return '10'
  else if (month === 'Dec') return '11'
}


export default function CardMonths () {
  const info = React.useContext(StateDispatch)
  
  const mapMonths = [
    {
      subject: 'Gen', A: 0,  fullMark: 4000,
    },
    {
      subject: 'Feb', A: 0, fullMark: 4000,
    },
    {
      subject: 'Mar', A: 0,  fullMark: 4000,
    },
    {
      subject: 'Apr', A: 0,  fullMark: 4000,
    },
    {
      subject: 'May', A: 0, fullMark: 4000,
    },
    {
      subject: 'Jun', A: 0, fullMark: 4000,
    },
    {
      subject: 'Jul', A: 0,  fullMark: 4000,
    },
    {
      subject: 'Aug', A: 0,  fullMark: 4000,
    },
    {
      subject: 'Sep', A: 0,  fullMark: 4000,
    },
    {
      subject: 'Oct', A: 0,  fullMark: 4000,
    },
    {
      subject: 'Nov', A: 0, fullMark: 4000,
    },
    {
      subject: 'Dec', A: 0, fullMark: 4000,
    }
  ]

    for (let i = 0; i < info.length; i++) { 
      let curClient = info[i]

      for (let j = 0; j < curClient.orders.length; j++) {
        let curOrder = curClient.orders[j]
        let curMonth = moment.unix(curOrder.rentdate).format("MMM")
        let indexCurMonth = Number(transformMonth(curMonth))

        mapMonths[indexCurMonth].A++
      }
    }
  

  return (
    <CardMonthsWrapper>
      <Title>Sales</Title>
      <RadarChartWrapper>
        <RadarChart cx={'50%'} cy={'50%'} outerRadius={100} width={290} height={260} data={mapMonths}>
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis />
          <Radar name="Mike" dataKey="A" stroke="#4285F4" fill="#4285F4" fillOpacity={0.6} />
        </RadarChart>
      </RadarChartWrapper>
    </CardMonthsWrapper>
      
  )
}